<template>
  <header class="bg-white shadow-md">
    <div class="container mx-auto px-4 py-6">
      <div class="flex items-center justify-center">
        <h1 class="text-3xl font-bold text-gray-900">
          CZK Exchange Rate Dashboard
        </h1>
      </div>
      <p class="text-center text-gray-600 mt-2">
        Real-time and historical exchange rates for Czech Koruna
      </p>
    </div>
  </header>
</template>

<script setup lang="ts">
// Simple header component as per PRD requirements
</script>
